<template>
  <div v-if="kpi" id="jobStats">
    <div v-if="kpi.kpiCompany !== null" class="stats">
      <div
        class="stat pending"
        :class="{ isNotClickable: kpi.count_jobs_pending === 0 }"
        @click="mxJobPending"
      >
        {{ kpi.count_jobs_pending }}
        <span>{{
          kpi.count_jobs_pending > 1 ? 'missions' : 'mission'
        }} {{ kpi.count_jobs_pending > 1 ? 'planifiées' : 'planifiée' }}</span></div>
      <div
        class="stat done"
        :class="{ isNotClickable: kpi.count_jobs_done === 0 }"
        @click="mxJobEnd"
      >
        {{ kpi.count_jobs_done }}
        <span>{{ kpi.count_jobs_done > 1 ? 'missions' : 'mission' }} {{
          kpi.count_jobs_done > 1 ? 'passées' : 'passée'
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useAccountStore } from '@/stores/account';
import { useCompanyStore } from '@/stores/company';

export default {
  computed: {
    ...mapStores(useAccountStore, useCompanyStore),
    kpi() {
      return this.companyStore.kpiCompany;
    },
  },
  methods: {
    goToJobFiltered(filter) {
      if (filter === 'done') {
        this.$router.replace({ path: 'job', query: { status: 'done' } });
      } else if (this.accountStore
        && this.accountStore.kpi
        && this.accountStore.kpi.count_jobs_pending !== 0) {
        this.$router.replace({ path: 'job', query: { status: 'all' } });
      }
    },
    mxJobPending() {
      this.goToJobFiltered('all');
    },
    mxJobEnd() {
      this.goToJobFiltered('done');
    },
  },
};
</script>
